import React, { createContext, useState } from "react";

interface GenerateEventSessionsContextType {
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
  element: any;
  setElement: (element: any) => void;  
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  modelId: any;
  setModelId: (modelId: any) => void;
}

export const GenerateEventSessionsContext = createContext<GenerateEventSessionsContextType>({  
  showModal: false,
  setShowModal: () => {},
  element: null,
  setElement: () => {},
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  modelId: null,
  setModelId: () => {},
});

interface GenerateEventSessionsProviderProps {
  children: React.ReactNode;
}

export const GenerateEventSessionsProvider: React.FC<GenerateEventSessionsProviderProps> = ({
  children,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [element, setElement] = useState<any>(null);
  const [backendFormErrors, setBackendFormErrors] = useState<any>({});
  const [modelId, setModelId] = useState<any>(null);


  const value = {
    showModal,
    setShowModal,
    element,
    setElement,
    backendFormErrors,
    setBackendFormErrors,
    modelId,
    setModelId,
  };
  return (
    <GenerateEventSessionsContext.Provider value={value}>
      {children}
    </GenerateEventSessionsContext.Provider>
  );
};
